<div [formGroup]="contactInfo">
  @for (addressGroup of addresses; track addressGroup; let i = $index) {
    <div>
      <ng-container [ngTemplateOutlet]="AddressTemplate" [ngTemplateOutletContext]="{ $implicit: i, group: addressGroup  }"></ng-container>
    </div>
  }

  @for (emailGroup of emails; track emailGroup; let i = $index) {
    <div>
      <ng-container [ngTemplateOutlet]="EmailTemplate" [ngTemplateOutletContext]="{ $implicit: i, group: emailGroup }"></ng-container>
    </div>
  }

  @for (orgGroup of organisations; track orgGroup; let i = $index) {
    <div>
      <ng-container [ngTemplateOutlet]="OrganisationTemplate" [ngTemplateOutletContext]="{ $implicit: i, group: orgGroup }"></ng-container>
    </div>
  }

  @for (phoneGroup of phones; track phoneGroup; let i = $index) {
    <div>
      <ng-container [ngTemplateOutlet]="PhoneTemplate" [ngTemplateOutletContext]="{ $implicit: i, group: phoneGroup }"></ng-container>
    </div>
  }

  @for (urlGroup of urls; track urlGroup; let i = $index) {
    <div>
      <ng-container [ngTemplateOutlet]="URLTemplate" [ngTemplateOutletContext]="{ $implicit: i, group: urlGroup }"></ng-container>
    </div>
  }

  @for (birthdayGroup of birthdays; track birthdayGroup; let i = $index) {
    <div>
      <ng-container [ngTemplateOutlet]="BirthdayTemplate" [ngTemplateOutletContext]="{ $implicit: i, group: birthdayGroup }"></ng-container>
    </div>
  }
</div>

<ng-template #AddressTemplate let-i let-group="group">
  <ng-container [formGroup]="group">
    <mat-expansion-panel class="expansion-panel" [expanded]="true">
      <mat-expansion-panel-header class="contact-template-header">
        <ng-container [ngTemplateOutlet]="templateHeader"
          [ngTemplateOutletContext]="{ $implicit: i, src: 'assets/svg/house.svg', label: 'Address', contactTypes: ContactTypes.ADDRESS }">
        </ng-container>
      </mat-expansion-panel-header>
      <div class="input-fields">
        <input class="control-input" formControlName="type" placeholder="Address Type" [matAutocomplete]="auto" #addressTypeFilter style="margin-bottom: 10px" >
        <input-validators controlParent="ContactInfo" controlName="type" [control]="group.controls['type']"></input-validators>
        <mat-autocomplete #auto="matAutocomplete">
          @for (option of addressFilteredOptions; track option) {
            <div>
              @if (option.toLowerCase().includes(addressTypeFilter.value)) {
                <mat-option [value]="option">
                  {{option}}
                </mat-option>
              }
            </div>
          }
        </mat-autocomplete>

        <div class="control-div">
          <textarea formControlName="street" class="control-textArea" style="margin-bottom: 5px;resize: none; min-height: 80px !important;" placeholder="Enter an Address"  ></textarea>
          <input-validators controlParent="ContactInfo" controlName="address" [control]="group.controls['street']"></input-validators>
        </div>

        <div class="control-div">
          <input  activeForm [activeForm]="contactInfo" class="control-input" id="city" placeholder="Enter a City" style="margin-bottom: 10px" formControlName="city">
          <input-validators controlParent="ContactInfo" controlName="city" [control]="group.controls['city']"></input-validators>
        </div>

        <div class="control-div">
          <input  activeForm [activeForm]="contactInfo" class="control-input" id="province" placeholder="Enter a Province / State" style="margin-bottom: 10px" formControlName="state">
          <input-validators controlParent="ContactInfo" controlName="state" [control]="group.controls['state']"></input-validators>
        </div>

        <div class="control-div">
          <input  activeForm [activeForm]="contactInfo" class="control-input" id="zip" placeholder="Enter a ZIP / Postal Code" style="margin-bottom: 10px" formControlName="zip">
          <input-validators controlParent="ContactInfo" controlName="zip" [control]="group.controls['zip']"></input-validators>
        </div>

        <app-country-select [countrySelect]="group.controls['country']"></app-country-select>
      </div>
    </mat-expansion-panel>
  </ng-container>
</ng-template>

<ng-template #EmailTemplate let-i let-group="group">
  <ng-container [formGroup]="group">
    <mat-expansion-panel class="expansion-panel" [expanded]="true">
      <mat-expansion-panel-header class="contact-template-header">
        <ng-container [ngTemplateOutlet]="templateHeader"
          [ngTemplateOutletContext]="{ $implicit: i, src: 'assets/svg/email.svg', label: 'Email', contactTypes: ContactTypes.EMAIL }">
        </ng-container>
      </mat-expansion-panel-header>
      <div class="input-fields">
        <input class="control-input" formControlName="type" [matAutocomplete]="auto" #emailTypeFiler placeholder="Email Type" style="margin-bottom: 10px">
        <input-validators controlParent="ContactInfo" controlName="type" [control]="group.controls['type']"></input-validators><mat-autocomplete #auto="matAutocomplete">
        @for (option of emailTypes; track option) {
          <div>
            @if (option.toLowerCase().includes(emailTypeFiler.value.toLowerCase())) {
              <mat-option [value]="option">
                {{option}}
              </mat-option>
            }
          </div>
        }
      </mat-autocomplete>
      <input class="control-input" placeholder="Email Address" style="margin-bottom: 10px" [email]="true" formControlName="email">
      @if (group.controls['email'].errors) {
        <div class="validationField">
          <span class="fa fa-exclamation-circle"></span>
          Email must be a valid email address
        </div>
      }
    </div>
  </mat-expansion-panel>
</ng-container>
</ng-template>

<ng-template #OrganisationTemplate let-i let-group="group">
  <ng-container [formGroup]="group">
    <mat-expansion-panel class="expansion-panel" [expanded]="true">
      <mat-expansion-panel-header class="contact-template-header">
        <ng-container [ngTemplateOutlet]="templateHeader"
          [ngTemplateOutletContext]="{ $implicit: i, src: 'assets/svg/organisation.svg', label: 'Organisation', contactTypes: ContactTypes.ORGANISATION }">
        </ng-container>
      </mat-expansion-panel-header>
      <div class="input-fields">
        <input class="control-input" placeholder="Title" style="margin-bottom: 10px" formControlName="title">
        <input-validators controlParent="ContactInfo" controlName="title" [control]="group.controls['title']"></input-validators>

        <input class="control-input" placeholder="Department" style="margin-bottom: 10px" formControlName="department">
        <input-validators controlParent="ContactInfo" controlName="department" [control]="group.controls['department']"></input-validators>

        <input class="control-input" placeholder="Company Name" style="margin-bottom: 10px" formControlName="company">
        <input-validators controlParent="ContactInfo" controlName="companyName" [control]="group.controls['company']"></input-validators>
      </div>
    </mat-expansion-panel>
  </ng-container>
</ng-template>

<ng-template #PhoneTemplate let-i let-group="group">
  <ng-container [formGroup]="group">
    <mat-expansion-panel class="expansion-panel" [expanded]="true">
      <mat-expansion-panel-header class="contact-template-header">
        <ng-container [ngTemplateOutlet]="templateHeader"
          [ngTemplateOutletContext]="{ $implicit: i, src: 'assets/svg/newphone.svg', label: 'Phone', contactTypes: ContactTypes.PHONE }">
        </ng-container>
      </mat-expansion-panel-header>
      <div class="input-fields">
        <input class="control-input" [matAutocomplete]="auto" placeholder="Number Type" #phoneTemplateFilter style="margin-bottom: 10px" formControlName="type">
        <input-validators controlParent="ContactInfo" controlName="type" [control]="group.controls['type']"></input-validators>
        <mat-autocomplete #auto="matAutocomplete">
          @for (option of phoneTypes; track option) {
            <div>
              @if (option.toLowerCase().includes(phoneTemplateFilter.value.toLowerCase())) {
                <mat-option [value]="option">
                  {{option}}
                </mat-option>
              }
            </div>
          }
        </mat-autocomplete>
        <input class="control-input" placeholder="Enter Phone Number" style="margin-bottom: 10px" formControlName="phone">
        <input-validators controlParent="ContactInfo" controlName="phoneNumber" [control]="group.controls['phone']"></input-validators>
        <div class="control-div toggle-field">
          <div class="label-left-block">
            <label class="control-label"> Include WhatsApp Contact Buttons </label>
          </div>
          <div class="toggle-btn">
            <mat-slide-toggle [color]="'primary'" class="control-toggle"
              [formControlName]="'waId'">
            </mat-slide-toggle>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </ng-container>
</ng-template>

<ng-template #URLTemplate let-i let-group="group">
  <ng-container [formGroup]="group">
    <mat-expansion-panel class="expansion-panel" [expanded]="true">
      <mat-expansion-panel-header class="contact-template-header">
        <ng-container [ngTemplateOutlet]="templateHeader"
          [ngTemplateOutletContext]="{ $implicit: i, src: 'assets/svg/url.svg', label: 'URL', contactTypes: ContactTypes.URL }">
        </ng-container>
      </mat-expansion-panel-header>
      <div class="input-fields">
        <input class="control-input" [matAutocomplete]="auto" #urlTemplateFilter placeholder="URL Type" style="margin-bottom: 10px" formControlName="type">
        <input-validators controlParent="ContactInfo" controlName="urlType" [control]="group.controls['type']"></input-validators>
        <mat-autocomplete #auto="matAutocomplete">
          @for (option of urlTypes; track option) {
            <div>
              @if (option.toLowerCase().includes(urlTemplateFilter.value.toLowerCase())) {
                <mat-option [value]="option">
                  {{option}}
                </mat-option>
              }
            </div>
          }
        </mat-autocomplete>
        <input class="control-input" placeholder="Enter URL Address" style="margin-bottom: 10px" formControlName="url">
        <input-validators controlParent="ContactInfo" controlName="value" [control]="group.controls['url']"></input-validators>
      </div>
    </mat-expansion-panel>
  </ng-container>
</ng-template>

<ng-template #BirthdayTemplate let-i let-group="group">
  <ng-container [formGroup]="group">
    <mat-expansion-panel class="expansion-panel" [expanded]="true">
      <mat-expansion-panel-header class="contact-template-header">
        <ng-container [ngTemplateOutlet]="templateHeader"
          [ngTemplateOutletContext]="{ $implicit: i, src: 'assets/svg/birthday.svg', label: 'Birthday', contactTypes: ContactTypes.BIRTHDAY }">
        </ng-container>
      </mat-expansion-panel-header>
      <div class="input-fields">
        <input class="control-input" placeholder="yyyy-mm-dd" style="margin-bottom: 10px" formControlName="birthday">
        @if (group.controls['birthday'].errors) {
          <div class="validationField">
            <span class="fa fa-exclamation-circle"></span>
            Invalid Birthday Format
          </div>
        }
      </div>
    </mat-expansion-panel>
  </ng-container>
</ng-template>


<ng-template #templateHeader let-i let-src="src" let-contactTypes="contactTypes" let-label="label">
  <div class="header-icon">
    <img [alt]="label" [src]="src" class="template-icon">
  </div>
  <div class="header-label">
    <label class="template-title" >{{label}}</label>
  </div>
  <div class="header-button">
    <button (click)="deleteTemplate(i, contactTypes)">
      <img alt="delete" src="assets/svg/delete-bin.svg">
    </button>
  </div>
</ng-template>